import { useFormContext } from 'react-hook-form';

import { FormValues } from './components/address-book-form';

export const useAddressBookFormContext = useFormContext<FormValues>;
